/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/**
 * WYSIWYG Block Frontend Functionality
 * 
 * Handles Gravity Forms integration within WYSIWYG blocks:
 * - Adds 'gf-filled' class to text/email fields with values
 * - Repositions labels for custom-input fields to appear below inputs
 */

(function () {
    'use strict';

    // Configuration
    const CONFIG = {
        wysiwygSelector: '.wp-block-block-builder-by-arc-wysiwyg',
        fieldSelector: '.gfield-custom-input input[type="text"], .ginput-container input[type="email"]',
        customInputSelector: '.gfield-custom-input',
        filledClass: 'gf-filled',
        labelSelector: '.gfield_label',
        inputContainerSelector: '.ginput_container'
    };

    /**
     * Updates the 'gf-filled' class based on field value
     * @param {HTMLElement} field - The input field element
     */
    function updateFieldClass(field) {
        const hasValue = field.value.trim().length > 0;

        if (hasValue) {
            field.classList.add(CONFIG.filledClass);
        } else {
            field.classList.remove(CONFIG.filledClass);
        }
    }

    /**
     * Repositions labels for custom-input fields to appear below inputs
     */
    function repositionLabels() {
        const wysiwygBlocks = document.querySelectorAll(CONFIG.wysiwygSelector);

        wysiwygBlocks.forEach(function (wysiwygBlock) {
            const customInputFields = wysiwygBlock.querySelectorAll(CONFIG.customInputSelector);

            customInputFields.forEach(function (fieldContainer) {
                const label = fieldContainer.querySelector(CONFIG.labelSelector);
                const inputContainer = fieldContainer.querySelector(CONFIG.inputContainerSelector);

                // Only move label if it exists and is currently outside the input container
                if (label && inputContainer && !inputContainer.contains(label)) {
                    inputContainer.appendChild(label);
                }
            });
        });
    }

    /**
     * Initializes all field states on page load
     */
    function initializeFields() {
        const wysiwygBlocks = document.querySelectorAll(CONFIG.wysiwygSelector);

        wysiwygBlocks.forEach(function (wysiwygBlock) {
            const fields = wysiwygBlock.querySelectorAll(CONFIG.fieldSelector);
            fields.forEach(updateFieldClass);
        });
    }

    /**
     * Handles input events for real-time field class updates
     * @param {Event} event - The input event
     */
    function handleInputEvent(event) {
        const wysiwygBlock = event.target.closest(CONFIG.wysiwygSelector);

        if (wysiwygBlock && event.target.matches(CONFIG.fieldSelector)) {
            updateFieldClass(event.target);
        }
    }

    /**
     * Handles change events for field class updates
     * @param {Event} event - The change event
     */
    function handleChangeEvent(event) {
        const wysiwygBlock = event.target.closest(CONFIG.wysiwygSelector);

        if (wysiwygBlock && event.target.matches(CONFIG.fieldSelector)) {
            updateFieldClass(event.target);
        }
    }

    /**
     * Initialize functionality when DOM is ready
     */
    function init() {
        initializeFields();
        repositionLabels();

        document.addEventListener('input', handleInputEvent);
        document.addEventListener('change', handleChangeEvent);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
